import { DivineControls } from "divine-controls";
import { PlayerActions } from "./PlayerActions";
import { APP_STATE } from "../client/State/AppState";
import { UISystem } from "../system/ui/UISystem";
import { RenderSystem } from "../system/render/RenderSystem";
export async function SetUpControls(player) {
    const PlayerManager = player.manager;
    PlayerManager.physics.nowIs.still();
    DivineControls.registerControlGroups([
        {
            id: "#dve_movement",
            name: "Movement",
        },
        {
            id: "#dve_action",
            name: "Actions",
        },
        {
            id: "#dve_menu",
            name: "Menus",
        },
    ]);
    DivineControls.registerControls([
        /*
       [[Movement]]
        */
        {
            id: "#dve_move_forward",
            groupId: "#dve_movement",
            name: "Move Forward",
            input: {
                keyboard: {
                    key: "w",
                    mode: "down",
                },
            },
            action: () => {
                if (!player.active)
                    return;
                PlayerManager.physics.nowIs.walkingForward();
            },
            onDone: () => {
                console.log("done");
                PlayerManager.physics.nowIs.walkingForward(false);
            },
        },
        {
            id: "#dve_move_backward",
            groupId: "#dve_movement",
            name: "Move Backward",
            input: {
                keyboard: {
                    key: "s",
                    mode: "down",
                },
            },
            action: () => {
                if (!player.active)
                    return;
                PlayerManager.physics.nowIs.walkingBackward();
            },
            onDone: () => {
                PlayerManager.physics.nowIs.walkingBackward(false);
            },
        },
        {
            id: "#dve_move_left",
            groupId: "#dve_movement",
            name: "Move Left",
            input: {
                keyboard: {
                    key: "a",
                    mode: "down",
                },
            },
            action: () => {
                if (!player.active)
                    return;
                PlayerManager.physics.nowIs.walkingLeft();
            },
            onDone: () => {
                PlayerManager.physics.nowIs.walkingLeft(false);
            },
        },
        {
            id: "#dve_move_right",
            groupId: "#dve_movement",
            name: "Move Right",
            input: {
                keyboard: {
                    key: "d",
                    mode: "down",
                },
            },
            action: () => {
                if (!player.active)
                    return;
                PlayerManager.physics.nowIs.walkingRight();
            },
            onDone: () => {
                PlayerManager.physics.nowIs.walkingRight(false);
            },
        },
        /*
       [[Actions]]
        */
        {
            id: "#dve_action_open_voxel_screen",
            groupId: "#dve_action",
            name: "Open Voxel Screen",
            input: {
                keyboard: {
                    key: "q",
                    mode: "down",
                },
            },
            action: () => {
                console.log("sup bro", APP_STATE);
                if (APP_STATE.mode == "in-game") {
                    APP_STATE.mode = "game-menu";
                    UISystem.appScreen.update("voxels", "game-screen");
                    UISystem.show(true);
                    RenderSystem.exitPointerLock();
                    RenderSystem.setCanvasInteractive(false);
                    return;
                }
                if (APP_STATE.mode == "game-menu") {
                    APP_STATE.mode = "in-game";
                    UISystem.show(false);
                    RenderSystem.setCanvasInteractive(true);
                    return;
                }
            },
        },
        {
            id: "#dve_action_use_item",
            groupId: "#dve_action",
            name: "Use Item",
            input: {
                mouse: {
                    button: "primary",
                    mode: "down",
                },
            },
            action: () => {
                if (!player.active)
                    return;
                player.picker.setPickNormals();
                PlayerActions.voxel.break();
            },
        },
        {
            id: "#dve_actino_interact",
            groupId: "#dve_action",
            name: "Interact",
            input: {
                type: "mouse",
                button: "secondary",
                mode: "down",
            },
            action: () => {
                if (!player.active)
                    return;
                player.picker.setPickNormals();
                PlayerActions.voxel.place();
            },
        },
        {
            id: "#dve_action_jump",
            groupId: "#dve_action",
            name: "Jump",
            input: {
                keyboard: {
                    key: " ",
                    mode: "down",
                },
            },
            action: () => {
                if (!player.active)
                    return;
                PlayerManager.physics.nowIs.jumping();
            },
            onDone: () => {
                PlayerManager.physics.nowIs.jumping(false);
            },
        },
        {
            id: "#dve_action_run",
            groupId: "#dve_action",
            name: "Run",
            input: {
                keyboard: {
                    key: "Control",
                    mode: "down",
                },
            },
            action: () => {
                if (!player.active)
                    return;
                PlayerManager.physics.nowIs.running();
            },
            onDone: () => {
                PlayerManager.physics.nowIs.running(false);
            },
        },
        /*
       [[Menus]]
        */
    ]);
    DivineControls.$INIT();
}
